import { createEffect, on } from "solid-js";
import { updateProfileInputs } from "../forms";
import { solidstate } from ":setup/qstate";
import { account } from "../apis";
import { global } from ":shared/app";
import { Button } from ":ui/form";
export default function DetailsForm(props: { details: any }) {
  const Form = updateProfileInputs();
  Form.Email.control.markDisabled(true);
  // FormInputs.Track.control.markDisabled(true);
  const tracks = global.store.actions.platform.getTracks();
  const char_limit = 300;
  const $image_upload = solidstate.create({ name: null, size: null, new: false });
  createEffect(
    on(
      () => props.details,
      (data) => {
        // console.log("updated :: ", data);
        Form.Actions.update(data);
      }
    )
  );

  async function onSubmit(e: Event) {
    e.preventDefault();
    const values = Form.Actions.getValuesSnakecase();
    return account.put(values as any).then(() => {
      if ($image_upload.value.new) {
        $image_upload.set((s) => ({ ...s, new: false }));
      }
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Profile Updated!",
      });
    });
  }

  return (
    <form class="flex flex-col w-full h-fit overflow-auto">
      {/* image */}
      <section class="flex flex-row  mb-3 items-center gap-3 !<sm:(flex-col my-3 )">
        <Form.Image.InputFile
          accept="image/*"
          class="min-w-200px max-w-200px min-h-200px max-h-200px rounded-full border-dashed border-2 border-brand <sm:(w-275px)"
          elements={{
            overlay(props) {
              return (
                <div
                  class={`flex flex-col justify-center items-center text-center ${props.class}`}
                  onclick={props.onclick}
                >
                  <span class="absolute bg-bg-button w-full h-full opacity-40"></span>
                  <span class="text-text-button text-20px !z-10">{props.drag ? "Drop Files" : "Edit"}</span>
                </div>
              );
            },
            viewer({ placeholder, buffers, file }) {
              if (
                file != undefined &&
                (file.name !== $image_upload.value.name || file.size !== $image_upload.value.size)
              ) {
                $image_upload.set({ name: file.name, size: file.size, new: true });
              }
              return (
                <div class="w-auto h-auto">
                  <img
                    src={placeholder ?? "/images/placeholders/person.png"}
                    class="w-full h-full bg-cover object-cover "
                  />
                </div>
              );
            },
          }}
        />

        <div class="flex flex-col w-full h-full gap-1 !<md:(items-center text-center)">
          <p class="text-text-alt py-1 text-14px ">Recommended 500 x 500 px. JPG or PNG is allowed</p>
          <Button
            controls={{}}
            onclick={onSubmit}
            class="form-btn !w-fit"
            triggers={{
              manualStatus: $image_upload.value.new ? "valid" : "invalid",
            }}
            statusInvalid="Save Changes"
            statusValid="Save Changes"
            statusSubmit="Saving.."
          />
        </div>
      </section>
      <section class="grid grid-cols-[49%_49%] gap-x-2 w-full h-full children:(flex flex-col  w-full h-full) <sm:(grid-cols-1 !gap-x-0) ">
        <Form.FirstName.Label title="First Name" class="form-label">
          <Form.FirstName.Input autocomplete="First Name" type="text" class="form-input" placeholder={`First Name`} />
        </Form.FirstName.Label>

        <Form.LastName.Label title="Last Name" class="form-label">
          <Form.LastName.Input autocomplete="LastName" type="text" class="form-input" placeholder={`Last Name`} />
        </Form.LastName.Label>

        <Form.Email.Label title="Email" class="form-label">
          <Form.Email.Input autocomplete="Email" class="form-input" />
        </Form.Email.Label>

        <Form.Track.Label title="Track" class="form-label">
          <Form.Track.Select
            class="form-select"
            options={tracks.values}
            onNoOptions={() => {
              console.warn("no track options to select from");
              global.store.actions.toast.pushToast({
                type: "error",
                message: "Tracks list was not provided by admin!",
              });
            }}
          />
        </Form.Track.Label>

        <Form.Portfolio.Label title="Portfolio Link" class="form-label">
          <Form.Portfolio.Input
            autocomplete="Portfolio Link"
            type="text"
            class="form-input"
            placeholder={`https://...`}
          />
        </Form.Portfolio.Label>

        <Form.Major.Label title="Job Title" class="form-label">
          <Form.Major.Input class="form-input" />
        </Form.Major.Label>

        <Form.Bio.Label title="Bio" class="form-label sm:(col-span-2)">
          <Form.Bio.TextArea
            autocomplete="Bio"
            class="form-textarea"
            placeholder="Write a brief about yourself"
            maxlength={char_limit}
          />
        </Form.Bio.Label>
      </section>
      <Form.Actions.Button
        class="form-btn self-center !md:(w-20% self-end)"
        onclick={onSubmit}
        statusValid="Save Changes"
        statusInvalid="Save Changes"
      />
    </form>
  );
}
